// ============================================================================
// KOREAN TRANSLATIONS - BIBLE VERSES
// ============================================================================
// 강한 번호가 포함된 한국어 성경 구절 (개역개정)

export const bibleVersesKo = [
  {
    reference: "빌립보서 4:13",
    text: "내게 능력 주시는 자 안에서 내가 모든 것을 할 수 있느니라",
    version: "개역개정",
    theme: "힘",
    strongNumbers: {
      "능력": "G1743", // ἐνδυναμόω (endynamoo) = 힘을 주다
      "할 수 있느니라": "G2480" // ἰσχύω (ischyo) = 할 수 있다
    },
    context: "바울은 모든 상황에서 그리스도 안에서 우리가 받는 힘에 대해 말합니다"
  },
  {
    reference: "시편 23:1",
    text: "여호와는 나의 목자시니 내게 부족함이 없으리로다",
    version: "개역개정",
    theme: "신뢰",
    strongNumbers: {
      "목자": "H7462", // רָעָה (ra'ah) = 양을 치다
      "부족함": "H2637" // חָסֵר (chaser) = 부족하다
    },
    context: "다윗은 우리를 돌보시는 하나님의 섭리에 대한 신뢰를 표현합니다"
  },
  {
    reference: "요한복음 3:16",
    text: "하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니 이는 그를 믿는 자마다 멸망하지 않고 영생을 얻게 하려 하심이라",
    version: "개역개정",
    theme: "사랑",
    strongNumbers: {
      "사랑하사": "G25", // ἀγαπάω (agapao) = 무조건적으로 사랑하다
      "주셨으니": "G1325", // δίδωμι (didomi) = 주다
      "영생": "G166" // αἰώνιος (aionios) = 영원한
    },
    context: "예수님은 우리를 향한 하나님의 무한한 사랑을 드러내십니다"
  },
  {
    reference: "로마서 8:28",
    text: "우리가 알거니와 하나님을 사랑하는 자 곧 그의 뜻대로 부르심을 입은 자들에게는 모든 것이 합력하여 선을 이루느니라",
    version: "개역개정",
    theme: "섭리",
    strongNumbers: {
      "합력하여": "G4903", // συνεργέω (synergeo) = 함께 일하다
      "선": "G18" // ἀγαθός (agathos) = 좋은, 유익한
    },
    context: "바울은 하나님의 주권적 섭리와 목적을 확증합니다"
  },
  {
    reference: "잠언 3:5-6",
    text: "너는 마음을 다하여 여호와를 신뢰하고 네 명철을 의지하지 말라 너는 범사에 그를 인정하라 그리하면 네 길을 지도하시리라",
    version: "개역개정",
    theme: "지혜",
    strongNumbers: {
      "신뢰하고": "H982", // בָּטַח (batach) = 확신하다
      "명철": "H998", // בִּינָה (binah) = 이해
      "지도하시리라": "H3474" // יָשַׁר (yashar) = 곧게 하다
    },
    context: "솔로몬은 우리 자신의 지혜보다 하나님을 신뢰하라고 권면합니다"
  },
  {
    reference: "이사야 40:31",
    text: "오직 여호와를 앙망하는 자는 새 힘을 얻으리니 독수리가 날개치며 올라감 같을 것이요 달음박질하여도 곤비하지 아니하겠고 걸어가도 피곤하지 아니하리로다",
    version: "개역개정",
    theme: "새로워짐",
    strongNumbers: {
      "앙망하는": "H6960", // קָוָה (qavah) = 기다리다, 바라다
      "새 힘": "H3581", // כֹּחַ (koach) = 힘, 능력
      "곤비하지": "H3286" // יָעַף (ya'aph) = 지치다
    },
    context: "이사야는 주님을 기다리는 자들에게 주어지는 영적 갱신을 약속합니다"
  },
  {
    reference: "마태복음 11:28",
    text: "수고하고 무거운 짐 진 자들아 다 내게로 오라 내가 너희를 쉬게 하리라",
    version: "개역개정",
    theme: "안식",
    strongNumbers: {
      "수고하고": "G2872", // κοπιάω (kopiao) = 애쓰다
      "무거운 짐": "G5412", // φορτίζω (phortizo) = 짐을 지우다
      "쉬게 하리라": "G373" // ἀναπαύω (anapauo) = 쉬게 하다
    },
    context: "예수님은 지친 모든 이에게 자비로운 초대를 하십니다"
  }
];

export default bibleVersesKo;
